// extracted by mini-css-extract-plugin
export default {"buttoncls":"uploadpage_buttoncls__PTzMT","text":"uploadpage_text__VWxx6"};